import styled from 'styled-components';
import { ShortBody, SmallSectionHeader } from 'components/Typography';
import { Box, Grid } from '@material-ui/core';

const StyledCaptions = styled(ShortBody)`
  &&& {
    line-height: 16px;
    margin-bottom: 0px;
    color: #0075c9;
    margin-left: 12px;
    margin-right: 12px;
  }
`;

const ItemWrapper = styled(Box)`
  background-color: #e8f3f8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 40px;
  padding-left: 25px;
  cursor: pointer;
  &: hover {
    opacity: 0.9;
    background-color: #e8f3f8;
  }
`;

const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;

const SizedGridItem = styled(Grid)`
  && {
    margin-top: 2px;
    max-width: 100%;
  }
`;
export { StyledCaptions, ItemWrapper, SizedSmallSectionHeader, SizedGridItem };
